import styled from 'styled-components';

export const StyledMain = styled.main`
  display: grid;
  box-shadow: ${(p) => p.theme.shadows.x};
  grid-column: 2 / 13;
  grid-template-columns: repeat(11, ${(p) => p.theme.space[8]});

  @media (max-width: 976px) {
    display: unset;
    grid-column: 2 / end;
    grid-template-columns: unset;
  }
`;
